import React from 'react';
import { FaCrown, FaMedal, FaStar } from 'react-icons/fa';
import './ClassifiedTeams.css';

const RANK_META = [
  { icon: <FaCrown />, label: '1er lugar', className: 'rank-gold' },
  { icon: <FaMedal />, label: '2do lugar', className: 'rank-silver' },
];

const ClassifiedTeams = ({ classifiedTeams }) => {
  const groupKeys = Object.keys(classifiedTeams);

  if (!groupKeys.length) {
    return (
      <div className="empty-state">
        <h3><FaMedal /> Sin clasificados</h3>
        <p>Completa partidos de grupos para calcular clasificados.</p>
      </div>
    );
  }

  return (
    <div className="classified-teams">
      {groupKeys.map((groupName, groupIndex) => (
        <div
          key={groupName}
          className="classified-teams__group"
          style={{ animationDelay: `${groupIndex * 0.08}s` }}
        >
          <h3><FaStar /> Grupo {groupName}</h3>
          <ul className="classified-teams__list">
            {classifiedTeams[groupName].map((team, index) => {
              const meta = RANK_META[index] || RANK_META[RANK_META.length - 1];
              return (
                <li key={team.id} className={`classified-teams__item ${meta.className}`}>
                  <span className="classified-teams__rank-icon">{meta.icon}</span>
                  <span className="classified-teams__name">{team.name}</span>
                  <span className="classified-teams__label">{meta.label}</span>
                </li>
              );
            })}
          </ul>
        </div>
      ))}
    </div>
  );
};

export default ClassifiedTeams;
